import React from "react";
import { injectIntl } from "react-intl";
import { Paragraph } from "@trainline/depot-web";
import { spacers } from "@trainline/depot-web/css";
import {
  get12HourTimeFormat,
  ScreenReaderOnly,
  setZeroTimezoneOffset
} from "@trainline-shareable/utils";
import IconCallingPointIntermediate from "../../../assets/icons/IconCallingPointIntermediate";
import LivePlatformStatus from "../../LivePlatformStatus";
import LiveTimeStatus from "../../LiveTimeStatus";
import TrackItem from "../../TrackItem";
const IntermediateCallingPoint = ({ callingPoint, intl }) => {
  var _a;
  const data = (callingPoint == null ? void 0 : callingPoint.departure) || (callingPoint == null ? void 0 : callingPoint.arrival);
  const callingPointName = callingPoint.location.name;
  if (data) {
    const scheduleTime = (_a = data.schedule) == null ? void 0 : _a.time;
    const isUKLocale = intl.locale === "en-gb";
    const isUSLocale = intl.locale === "en-us";
    const accessibleTime = scheduleTime && intl.formatTime(new Date(setZeroTimezoneOffset(scheduleTime)), {
      hour: "numeric",
      minute: "numeric",
      hour12: false,
      timeZone: "UTC"
    });
    return /* @__PURE__ */ React.createElement(TrackItem, {
      style: { paddingBottom: spacers.dp_s16 }
    }, /* @__PURE__ */ React.createElement(TrackItem.Marker, null, /* @__PURE__ */ React.createElement(IconCallingPointIntermediate, null)), /* @__PURE__ */ React.createElement(TrackItem.Time, null, scheduleTime && /* @__PURE__ */ React.createElement(Paragraph, {
      as: "span",
      fontWeight: "semibold",
      color: "subtle"
    }, /* @__PURE__ */ React.createElement("time", {
      dateTime: scheduleTime
    }, (isUKLocale || isUSLocale) && accessibleTime && /* @__PURE__ */ React.createElement(ScreenReaderOnly, null, get12HourTimeFormat(accessibleTime)), /* @__PURE__ */ React.createElement("span", {
      "aria-hidden": isUKLocale || isUSLocale
    }, intl.formatTime(new Date(setZeroTimezoneOffset(scheduleTime)), {
      hour: "numeric",
      minute: "numeric",
      hour12: false,
      timeZone: "UTC"
    })))), /* @__PURE__ */ React.createElement(Paragraph, {
      as: "span",
      typeStyle: "mini",
      color: "subdued"
    }, /* @__PURE__ */ React.createElement(LiveTimeStatus, {
      callingPoint
    }))), /* @__PURE__ */ React.createElement(TrackItem.Info, null, /* @__PURE__ */ React.createElement(Paragraph, {
      as: "span",
      fontWeight: "semibold",
      color: "subtle"
    }, callingPointName), /* @__PURE__ */ React.createElement(Paragraph, {
      as: "span",
      typeStyle: "mini",
      color: "subdued"
    }, /* @__PURE__ */ React.createElement(LivePlatformStatus, {
      callingPoint
    }))));
  }
  return null;
};
var IntermediateCallingPoint_default = injectIntl(IntermediateCallingPoint);
export {
  IntermediateCallingPoint_default as default
};
